import script from "./DealerPerformanceWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DealerPerformanceWidget.vue?vue&type=script&setup=true&lang=js"

import "./DealerPerformanceWidget.vue?vue&type=style&index=0&id=6f2481c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2481c2"]])

export default __exports__